'use strict';

/**
 * Adjusts the home consultation fields
 * @param {jQuery} $kitchenConsultationField - Kitchen consultation field
 * @param {string} activeCheckboxID - truly selected input id
 * @returns {void}
 */
function adjustKitchenConsultation($kitchenConsultationField, activeCheckboxID) {
	var appointmentKitchenLocationHomeChecked = false;
	var appointmentKitchenLocationStoreChecked = false;
	var appointmentKitchenLocationVideoChecked = false;

	$kitchenConsultationField.find('input:checked').each(function () {
		var id = $(this).attr('id');
		if (!id || (activeCheckboxID && id !== activeCheckboxID)) {
			return;
		}

		if (id === 'appointment-location-home-checkbox') {
			appointmentKitchenLocationHomeChecked = true;
		} else if (id === 'appointment-location-store-checkbox') {
			appointmentKitchenLocationStoreChecked = true;
		} else if (id === 'appointment-location-video-checkbox') {
			appointmentKitchenLocationVideoChecked = true;
		}
	});

	var $branchOfficeContainer = $('.js-appointment-form .js-branch-office-container');
	$branchOfficeContainer
		.attr('hidden', appointmentKitchenLocationHomeChecked || appointmentKitchenLocationVideoChecked)
		.find('input')
		.prop('disabled', !(appointmentKitchenLocationStoreChecked));

	var $kitchenConsultationFieldWrap = $('.js-appointment-form .js-kitchen-consultation-fields-wrap');
	$kitchenConsultationFieldWrap
		.attr('hidden', !(appointmentKitchenLocationHomeChecked || appointmentKitchenLocationVideoChecked || appointmentKitchenLocationStoreChecked))
		.find('input, select, textarea')
		.prop('disabled', !(appointmentKitchenLocationHomeChecked || appointmentKitchenLocationVideoChecked || appointmentKitchenLocationStoreChecked));

	// init list checkboxes status
	var $status = $kitchenConsultationField.find('input.js-list-checkboxes-validity-status');
	if ($kitchenConsultationField.is(':visible')) {
		if ($status.length && $status.data('required')) {
			$status.prop('required', true);
		}
	} else {
		$status.prop('required', false);
	}
}

module.exports = {
	init: function () {
		adjustKitchenConsultation(
			$('.js-appointment-form .js-kitchen-consultation-location-container')
		);
	},

	appointmentForm: function () {
		$('.js-appointment-form').on('reset', function () {
			setTimeout(function () {
				$('.js-appointment-form .js-topic-field').triggerHandler('reset');
			}, 0);
		});
	},

	consultationCheckbox: function () {
		$('.js-appointment-form .js-kitchen-consultation-location-home-checkbox,.js-kitchen-consultation-location-store-checkbox,.js-kitchen-consultation-location-video-checkbox').on('change', function (e) {
			var $checkbox = $(this);
			var $kitchenConsultationField = $(this).parents('.js-kitchen-consultation-location-container');

			adjustKitchenConsultation($kitchenConsultationField, $checkbox.attr('id'));
		});
	},

	topicField: function () {
		$('.js-appointment-form .js-topic-field').on('change reset', function () {
			var isKitchenTopic = this.value === 'kitchen';
			var $kitchenConsultationLocationContainer = $('.js-appointment-form .js-kitchen-consultation-location-container');

			$kitchenConsultationLocationContainer
				.attr('hidden', !isKitchenTopic)
				.find('input:checked:not(.js-list-checkboxes-validity-status)')
				.prop('checked', false)
				.triggerHandler('change');

			$kitchenConsultationLocationContainer
				.find('input.js-list-checkboxes-validity-status')
				.prop('checked', !isKitchenTopic);

				adjustKitchenConsultation(
					$kitchenConsultationLocationContainer
				);
		});
	}
};
